const angular = require('angular');
const app = angular.module('learn-directives');
const moment = require('moment');
/**
 * Defines the Article-Viewer component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 * @argument {Analyze} Analyze the resource defined to manage Analyze
 * @argument {ImportedContent} ImportedContent the resource defined to manage ImportedContent
 * @argument {Assignments} Assignments the resource defined to manage Assignments
 */
app.directive('importedContentViewer', ['Application', 'Authorization', 'Analyze', 'ImportedContent', 'ContentAuth', 'SurveyHelper', '$translate', '$window', 'ImportedContentRegistrations', function(Application, Authorization, Analyze, ImportedContent, ContentAuth, SurveyHelper, $translate, $window, ImportedContentRegistrations) {
    return {
      restrict: 'E',
      scope: {
        checkFull: '@',
        fullData: '=',
        onComplete: '&',
        contentId: '=',
        specialClose: '&?',
        journeyId: '=?'
      },
      template: require('../../templates/directives/imported-content-viewer.html'),
      controller: ['$scope', function($scope) {
          var self = this;
          var adminRoles = ['admin', 'creator'];
          self.user = Authorization.getAuthToken().user;
          self.isAdmin = adminRoles.indexOf(self.user.role) !== -1;
          self.type = 'imported_content';
          self.course = {};

          self.activeAuthor = 0;
          self.totalDuration = 0;

          self.lightboxStatus = 'disabled';
          self.lightboxUrl = '';
          self.activateLightbox = function(url) {
            self.lightboxStatus = 'enabled';
            self.lightboxUrl = url;
          };

          self.hideSurvey = true;
          self.expandSurvey = false;
          self.inJourney = !!$scope.journeyId;

          self.recordSurveyView = () => {
            Analyze.record({resource: 'views'}, {content: self.course.surveys[0].survey_id, content_type: 'survey'});
          }

          self.tracking = new Application.Tracking(Analyze, moment, 'imported_content', $scope.trackId || null);

          self.setInitials = function() {
            self.routeParameters = Application.navigation.getRouteParameters();
            self.url = Application.navigation.getUrl();
            self.inEditing = new RegExp('edit').test(self.url);
            self.contentId = $scope.contentId || self.routeParameters.id || null;
            self.course = {};
          };
          self.setInitials();

          self.instructorLink = function(iLink) {
            if (new RegExp('//').test(iLink) || new RegExp('www').test(iLink)) {
              return iLink;
            }
            if (self.course.vendor && self.course.vendor === 'udemy') {
              return 'https://www.udemy.com' + iLink;
            }
          };

          self.addDurationWatch = function(get) {
            if (!get) {
              $scope.$watch('fullData.duration', function(newVal, oldVal) {
                if (newVal === oldVal) {
                  return;
                }
                self.course.duration = $scope.fullData.duration;
                if (self.course.duration) {
                  self.totalDuration = Math.round(self.course.duration / 3600) || 0;
                }
              });
              return;
            }
            $scope.$watch('importViewer.course', function(newVal, oldVal) {
              if (newVal === oldVal) {
                return;
              }
              self.course.duration = newVal.duration;
              if (self.course.duration) {
                self.totalDuration = Math.round(self.course.duration / 3600) || 0;
              }
            });
          };

          var setFull = function() {
            self.course = $scope.fullData;
            self.tracking.start(self.course);
            if (Application.navigation.getUrl().indexOf('edit') !== -1) {
              self.addDurationWatch();
            }
          };

          self.initialize = function() {
            if (!self.contentId && !$scope.fullData) {
              console.log('No id specified');
              Application.navigation.goToHome();
              return;
            }

            if ($scope.checkFull) {
              if ($scope.fullData) {
                setFull();
                return;
              }
              var fullWatch = $scope.$watch('fullData', function(newVal, oldVal) {
                if (newVal && !oldVal) {
                  setFull();
                  fullWatch();
                }
              }, true);
              return;
            }


            ImportedContent.get({
              subresource: self.contentId,
              fields: 'title,description,instructors,headline,learn_items,vendor,vendor_link,vendor_full_link,tags,image,banner_image,user,linked_category,explore_hide,duration,privacy_locations,privacy_departments,privacy_teams,privacy_org_levels,privacy_grades,private,lil_structure,difficulty,allow_comments,groups,surveys'
            }, function(data) {
              ContentAuth.allowView(data).then(function(allowed) {
                if (!allowed) {
                  $translate(['importedContent.permission_error']).then(function(translations){
                    Application.messaging.addMessage({type: 'error', text: translations['importedContent.permission_error'], duration: 5});
                    Application.navigation.back();
                  });
                  return;
                }
                Analyze.record({resource: 'views'}, {content: data._id, content_type: 'imported_content'});
                Application.analyticsProvider.trackEvent('imported_content_viewed', {content: data._id, content_type: 'imported_content', title: data.title});
                self.course = data;
                ImportedContentRegistrations.register({}, {content: self.course._id, user: self.user._id}, async function(data) {
                  self.registration = data;
                  self.progress_value = 0;
                  self.progress_label = '0%';
                  self.progress_style = {'width': '0%'};
                  if (self.course.surveys?.length && self.registration.completed) {
                    const hideInContext = self.inJourney || self.inTrack;
                    const hide = await SurveyHelper.hideSurvey(hideInContext, self.course.surveys[0].survey_id, self.course._id)
                    self.hideSurvey = hide;
                  }
                  if (self.registration.results) {
                    var latest_progress = self.registration.results.find(function(result) {
                      return result.name === 'latest_progress';
                    });
                    if (latest_progress) {
                      latest_progress.object = JSON.parse(latest_progress.value);
                      if (latest_progress.object.item_completion_ratio) {
                        self.progress_value = latest_progress.object.item_completion_ratio;
                        self.progress_label = parseInt(self.progress_value) + '%';
                        self.progress_style = {'width': self.progress_value + '%'};
                      }
                    }
                  }
                }, function(error) {
                  console.log('Error occured creating registration ', error);
                  Application.notifications.setError('Unable to create registration.');
                });
                if (self.course.duration) {
                  self.totalDuration = Math.round(self.course.duration / 3600) || 0;
                }
                self.tracking.start(self.course);
                if ($scope.onComplete) {
                  $scope.onComplete();
                } else if (self.inTrack) {
                  var completeWatch = $scope.$watch('onComplete', function(newVal, oldVal) {
                    if (newVal && !oldVal) {
                      $scope.onComplete();
                      completeWatch();
                    }
                  });
                } else if (self.inJourney) {
                  $scope.onComplete(self.course._id);
                }
                if (Application.navigation.getUrl().indexOf('edit') !== -1) {
                  self.addDurationWatch();
                }
              });
            }, function(error) {
              console.log('Error occured getting content ', self.contentId, error);
              Application.notifications.setError(self.translations['modules.notifications.unableToGetArticle']);
            });

          };
          self.image = function() {
            if (self.course.banner_image || self.course.image) {
              var imageUrl = self.course.banner_image ? self.course.banner_image : self.course.image;
              return Application.imageCdn.baseUrl + Application.imageCdn.sharedProps + '/' + imageUrl;
            }
            return '';
          };

          $translate(['modules.notifications.unableToGetArticle', 'edit.article.lessThanAMinute']).then(function(translations) {
            self.translations = translations;
            self.initialize();
          });

          $scope.$on('$destroy', function() {
            self.tracking.end();
          });

          $scope.$watch('contentId', function(newVal, oldVal) {
            if (!newVal || newVal === oldVal) {
              return;
            }
            self.setInitials();
            self.initialize();
          });

          self.goToCourse = function() {
            if (!self.registration) {
              ImportedContentRegistrations.register({}, {content: self.course._id, user: self.user._id}, function(data) {
                self.registration = data;
                $window.open(self.registration.content.vendor_full_link, '_blank');
              }, function(error) {
                console.log('Error occured creating registration ', error);
                Application.notifications.setError('Unable to create registration.');
              });
            } else {
              $window.open(self.registration.content.vendor_full_link, '_blank');
            }
          };

        }],
      controllerAs: 'importViewer'
    };
  }]);